module.exports = __webpack_public_path__ + "static/media/jack.ce5d81f6.jpg";